import type { TranslationMessages } from './types';

export const support: TranslationMessages = {
  title: 'Support',
  description: 'How can we help you? Choose an option below.',
  reportBug: 'Report a bug',
  viewFaq: 'View FAQ',
};
